// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockTitle__irpDE {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  min-height: 20px;
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__d_1hl {
  position: relative;
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.associatedSensorsTable__EZHR5 {
  width: 100%;
}
.associatedSensorsTable__EZHR5 thead {
  background-color: var(--tables-title-surface);
}
.associatedSensorsTable__EZHR5 th {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  min-width: 130px;
  padding: 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  position: sticky;
  top: 0;
}
.associatedSensorsTable__EZHR5 th:first-child {
  width: 70px;
  padding-left: 25px;
}
@media (max-width: 1400px) {
  .associatedSensorsTable__EZHR5 th {
    min-width: auto;
  }
}
.associatedSensorsTable__EZHR5 tr:hover {
  background-color: var(--tables-primary-row-surface-hover);
}
.associatedSensorsTable__EZHR5 td {
  font-size: 14px;
  line-height: 17px;
  color: var(--tables-primary-row-text-main);
  padding: 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.associatedSensorsTable__EZHR5 td:first-child {
  padding-left: 25px;
}
.associatedSensorsTable__EZHR5 td.cellEquipmentName__lN_QL {
  width: 400px;
  color: var(--buttons-surface);
  cursor: pointer;
}
.associatedSensorsTable__EZHR5 td.tachometerCell__gMjIL {
  text-transform: uppercase;
  color: var(--buttons-surface);
  cursor: pointer;
}

.noSensorText__L_qdw {
  font-size: 9px;
  line-height: 12px;
  color: var(--tables-primary-row-text-main);
  text-transform: uppercase;
  padding-top: 14px;
  padding-bottom: 14px;
}

.skeletonText__EGEBr {
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/EquipmentDetails/components/SensorsAssociated/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,2DAAA;EACA,wCAAA;AAzEF;;AA4EA;EACE,WAAA;AAzEF;AA2EE;EACE,6CAAA;AAzEJ;AA4EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,yDAAA;EACA,gBAAA;EACA,MAAA;AA1EJ;AA4EI;EACE,WAAA;EACA,kBAAA;AA1EN;AA6EI;EAlBF;IAmBI,eAAA;EA1EJ;AACF;AA8EI;EACE,yDAAA;AA5EN;AAgFE;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,aAAA;EACA,yDAAA;AA9EJ;AAgFI;EACE,kBAAA;AA9EN;AAiFI;EACE,YAAA;EACA,6BAAA;EACA,eAAA;AA/EN;AAkFI;EACE,yBAAA;EACA,6BAAA;EACA,eAAA;AAhFN;;AAqFA;EACE,cAAA;EACA,iBAAA;EACA,0CAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;AAlFF;;AAqFA;EACE,YAAA;AAlFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  position: relative;\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.associatedSensorsTable {\n  width: 100%;\n\n  thead {\n    background-color: var(--tables-title-surface);\n  }\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    color: var(--tables-title-text);\n    text-transform: uppercase;\n    text-align: left;\n    min-width: 130px;\n    padding: 15px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    position: sticky;\n    top: 0;\n\n    &:first-child {\n      width: 70px;\n      padding-left: 25px;\n    }\n\n    @media (max-width: 1400px) {\n      min-width: auto;\n    }\n  }\n\n  tr {\n    &:hover {\n      background-color: var(--tables-primary-row-surface-hover);\n    }\n  }\n\n  td {\n    font-size: 14px;\n    line-height: 17px;\n    color: var(--tables-primary-row-text-main);\n    padding: 15px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n    &:first-child {\n      padding-left: 25px;\n    }\n\n    &.cellEquipmentName {\n      width: 400px;\n      color: var(--buttons-surface);\n      cursor: pointer;\n    }\n\n    &.tachometerCell {\n      text-transform: uppercase;\n      color: var(--buttons-surface);\n      cursor: pointer;\n    }\n  }\n}\n\n.noSensorText {\n  font-size: 9px;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-main);\n  text-transform: uppercase;\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n\n.skeletonText {\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockTitle": `blockTitle__irpDE`,
	"blockContainer": `blockContainer__d_1hl`,
	"associatedSensorsTable": `associatedSensorsTable__EZHR5`,
	"cellEquipmentName": `cellEquipmentName__lN_QL`,
	"tachometerCell": `tachometerCell__gMjIL`,
	"noSensorText": `noSensorText__L_qdw`,
	"skeletonText": `skeletonText__EGEBr`
};
module.exports = ___CSS_LOADER_EXPORT___;
